<template>
  <div class="c-login-selector">
    <Dropdown
      v-if="logins.length > 0"
      ref="dropdown"
      class="dropdown-custom"
    >
      <Btn
        class="dropdown-toggle"
        type="default"
      >
        Логин в Яндекс.Директ
        <span class="caret" />
      </Btn>
      <template #dropdown>
        <li
          v-for="(item, index) in logins"
          :key="index"
          :class="{'active': item.active === true}"
        >
          <a
            role="button"
            @click="selectLogin(item.name)"
          >
            {{ item.text }}
          </a>
        </li>
      </template>
    </Dropdown>
  </div>
</template>

<script>
import { Btn, Dropdown, Notification } from 'uiv'
import { mapGetters, mapMutations } from 'vuex'
import apiService from '../../apiService'

export default {
  name: 'CLoginSelector',
  components: {
    Btn,
    Dropdown
  },
  data () {
    return {
      fetchingLogins: false,
      logins: []
    }
  },
  computed: {
    ...mapGetters({
      getLogin: 'Login/getLogin'
    })
  },
  mounted () {
    this.fetchLogins().then(this.onLoginsDataResolve)
  },
  methods: {
    ...mapMutations({
      setLogin: 'Login/setLogin'
    }),
    /**
     * Метод-обёртка над запросом к API /api/context/logins
     * @returns {Promise<AxiosResponse<T>>}
     */
    fetchLogins () {
      this.fetchingLogins = true
      return new Promise(resolve => {
        apiService.getLoginsData()
          .then(response => {
            this.fetchingLogins = false
            resolve(response.data)
          })
          .catch(data => {
            this.fetchingLogins = false
            Notification.notify.error({
              title: 'Ошибка',
              content: 'Не удалось получить список логинов.'
            })
          })
      })
    },
    /**
     * Метод занимается отрисовкой компонента списка логинов
     * @param data Данные из Promise
     */
    onLoginsDataResolve (data) {
      data.forEach((item, index) => {
        this.logins.push({
          name: item,
          text: item,
          active: this.getLogin
            ? item === this.getLogin
            : index === 0
        })
      })
    },
    /**
     * Устанавливает новый логин из списка и сохраняет его состояние
     * @param login Логин
     */
    selectLogin (login) {
      this.logins.forEach(item => {
        item.active = item.name === login
      })
      // Пишем в store
      this.setLogin(login)
    }
  }
}
</script>

<style scoped lang="scss">
  .c-login-selector {
    .dropdown-menu {
      li {
        & > a {
          text-decoration: none;
        }
      }
    }
  }
</style>
